import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, Icon } from "semantic-ui-react";
import { APPOINTMENT_NOTE_TYPES, handleFormatReplacementVehicleNote, getPickUpAndDropOfTimeStringReplacementCarNote } from "./util";

import "./CommunicationReplacementCarInfo.scss";

const CommunicationReplacementCarInfo = ({ appointment, t }) => {
  const replacementCarNote = appointment.notes?.find(note => note.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.REPLACEMENT_CAR);

  if (!replacementCarNote) return null;

  const { note, reg_nr, rental_pickup_time, rental_drop_off_time } = replacementCarNote;

  return (
    <div className="info-section">
      <div className="section-header">
        <span>{t("replacement_car").message || "Replacement Car"}</span>
      </div>
      <div className="section-content">
        <Grid>
          {reg_nr && (
            <Grid.Column width={4}>
              <span className="icon-text">
                {t("reg").message || "Reg"}
                <Icon name="hashtag" color="green" />
              </span>
              {reg_nr}
            </Grid.Column>
          )}

          <Grid.Column width={12}>
            <span className="icon-text">
              <Icon name="clock" color="green" />
            </span>
            {handleFormatReplacementVehicleNote(note, t)} {getPickUpAndDropOfTimeStringReplacementCarNote(rental_pickup_time, rental_drop_off_time)}
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
};

export default withTranslation()(CommunicationReplacementCarInfo);
